import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  pageListReport: {
    allCheckboxes: [],
    checkboxes: [],
    isCheckAll: false
  },
  detailReport: {
    payments: [],
    selected_report_id: null,
    detail_report: null,
    summary_report: null,
    summary_success_report: null,
    report_total_usd: 0,
    report_total_vnd: 0,
    summary_total_usd: 0,
    summary_total_vnd: 0,
    payment_total_vnd: 0,
    payment_total_usd: 0
  },
  rangeReport: {
    list: [],
    listOptions: []
  },
  autoReport: {
    selected_account: null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
